// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

// change host api
// export const HOST_API = 'http://localhost:8080';
export const HOST_API = 'https://api.countingtrucks.com';
// export const HOST_API = 'https://devapi.countingtrucks.com';
export const VERSION = '2.0.2';
export const APP_BRAND = '';
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

// Google Maps
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDKM9i9C5J9b5L8achpsu5UqV7CWHOWdRI';

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.app.root; // as '/dashboard'
export const PATH_AFTER_LOGIN_IFTA_ONLY = paths.app.ifta.list;
export const PATH_AFTER_LOGIN_DEVICE_ONLY = paths.app.devices.map;
export const PATH_AFTER_LOGIN_ELD_ONLY = paths.app.eldDashboard;
export const PATH_AFTER_LOGIN_RENTALS_ONLY = paths.app.rentals.trailers.list;
export const PATH_AFTER_LOGIN_IS_PARENT = paths.app.eldAssetsPerLandmark.list;
export const PATH_AFTER_REGISTER = paths.app.root; // as '/dashboard'
